'use client';

import { useRouter } from 'next/navigation';

export function NotFoundComponent() {
  const { back } = useRouter();
  return (
    <div className="card m-auto w-fit">
      <div className="card-body">
        <h2 className="card-title">Not Found</h2>
        <p>Could not find requested resource</p>
        <div className="flex items-center gap-3">
          <button onClick={back} className="btn">
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
